import React from 'react';

import { useQuery } from '@tanstack/react-query';
import { DialogContent } from '@mui/material';
import _ from 'lodash';
import { ConnectorSteps } from './connectors/ConnectorSteps';

import { getConnectorSchema } from '../../../api/connectors/connectors.api';
import useNotifications from '../../../_lib/notifications/useNotifications';

export const GenericConnector = ({ data: tileData, ...props }) => {
  const notifications = useNotifications();
  const { cbid, connectorType } = tileData;

  const handleClose = () => {
    props.close();
  };

  const schemaQuery = useQuery(
    ['connectors', { connectorType }],
    () => getConnectorSchema(connectorType),
    {
      onError: () => {
        notifications.error(
          'There was a problem loading connector data, please try again'
        );
      },
    }
  );

  // Never return null into an open DialogBase — that leaves a title-only
  // shell (the "thin bar" on Connectors). Keep the dialog body mounted.
  if (schemaQuery.isLoading || _.isEmpty(schemaQuery.data)) {
    return <DialogContent />;
  }

  return (
    <ConnectorSteps
      handleClose={handleClose}
      schema={schemaQuery.data}
      cbid={cbid}
      connectorType={connectorType}
    />
  );
};

export const GenericConnectorConfig = {
  GenericConnector: {
    component: GenericConnector,
    // all mui related config
    config: {
      maxWidth: 'sm',
    },
  },
};
